import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=30fa9c85&scoped=true"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=30fa9c85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa9c85",
  null
  
)

export default component.exports